export default {
    // 获取枚举值
    getEnumItem(column, data) {
        if (!data) return;
        if (typeof data == "object" && data.length) {
            let checkData = column.enumData
                .map((item) => {
                    return data.indexOf(item.value || item.id) > -1 ?
                        item.name || item.label :
                        null;
                })
                .filter(Boolean);
            return checkData.toString();
        } else {
            let enumItem = column.enumData.filter((item) => {
                return item.id == data || item.value == data;
            });
            if (enumItem.length == 0) {
                return `<span class="status-item">${data}</span>`;
            } else {
                enumItem = enumItem[0];
                return `<span class="status-item ${enumItem.class}">${
              enumItem.name || enumItem.label
            }</span>`;
            }
        }
    },
    printCss() {
        return `.print-dom{
        display:block;
        position:relative;
      }
      .print-dom .el-col-12 {
              width: 50%;
          }
          .el-col-24 {
              width: 100%;
          }
          .print-dom .print-title{
            text-align:center;
            font-size:24px;
          }
          .print-dom .el-form-item{
            min-height:30px;
          }
          .print-dom .el-form-item__label{
              text-align: right;
              vertical-align: middle;
              float: left;
              font-size: 12px;
              line-height: 20px;
              padding: 0 20px 0 0;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
          }
          .print-dom .el-form-item__content{
            line-height: 20px;
            font-size: 12px;
          }
          .print-title{
              text-align: center;
            }
            .print-top-content{
              display: flex;
              height:30px;
              line-height: 30px;
              font-size: 14px;
              color:#999;
            }
            .status-image {
              position: absolute;
              right: 150px;
            }
          .print-dom .print-person-sign{
            max-width: 100%;
            display:flex;
            justify-content:space-between;
          }
          .print-dom .print-person-sign p{
              font-size:12px;
              width:30%;
          }
          .print-dom .print-table td{
              height:30px;
              text-align:center;
              font-size:12px;
          }
          .el-radio__label, .el-checkbox__label, .el-form-item__label {
              font-size: 13px;
              letter-spacing: 1px;
          }
          .el-form-item__content, .el-form-item__label{
              line-height: 3.4rem;
              font-size: 1.4rem;
          }
          [class*=el-col-] {
              float: left;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
          }
          .detail.page-content .form-box {
              padding: 20px;
              position: relative;
          }
          .detail.page-content .table-box {
              margin-top: 20px;
              padding: 20px;
              border-radius: 5px;
              max-width: 100%;
          } .el-form-item, .el-form-item .el-form-item {
              min-height: 50px;
              margin-bottom: 0;
          }.el-form-item__content {
              position: relative;
          }
          .el-table{
            padding:3px;
            max-width:100%;
          }
          .el-table th{
            font-weight:normal;
          }
          .el-table td,.el-table th{
            font-size:12px;
              line-height:35px;
              border:1px solid #666;
          }
          .el-table td.is-center, .el-table th.is-center {
              text-align: center;
          }.el-form-item__label {
              padding-right: 9px;
          }.status-image {
              position: absolute;
              top: 10px;
              right: 80px;
              width: 164px;
              height: 87px;
              background-size: 100% 100%;
              z-index: 1000;
          }`
    },
}



// WEBPACK FOOTER //
// ./src/utils/business.js